import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AlimtalkApiV2 } from '../../../lib/api/alimtalk/AlimtalkApiV2';
import { ErrorResponseType } from '../../../lib/utils/checkErrorResponse';
import { CreateAlimtalkSendDto, PreviewAlimtalkSendResponse } from '../../../types/alimtalk/send';

/** 실패 처리(사유 표시·재시도)는 호출부(useAlimtalkSendForm.requestPreview)의 콜백이 담당 */
export const usePreviewAlimtalkSendMutation = (): UseMutationResult<
  PreviewAlimtalkSendResponse,
  ErrorResponseType,
  CreateAlimtalkSendDto
> =>
  useMutation({
    mutationFn: (dto: CreateAlimtalkSendDto) => AlimtalkApiV2.previewSend(dto),
  });
